/* EYE COLLECTION */
import SitaKajalBack from '../assets/products/eye-01-back.webp';
import SitaKajalFront from '../assets/products/eye-01-front.webp';
import BombshellBrowBack from '../assets/products/eye-02-back.webp';
import BombshellBrowFront from '../assets/products/eye-02-front.webp';
import HollywoodIconBack from "../assets/products/eye-03-back.webp";
import HollywoodIconFront from "../assets/products/eye-03-front.webp";
import HollywoodIconSapphireBack from "../assets/products/eye-04-back.webp";
import HollywoodIconSapphireFront from "../assets/products/eye-04-front.webp";
import HollywoodIconRodeoBack from "../assets/products/eye-05-back.webp";
import HollywoodIconRodeoFront from "../assets/products/eye-05-front.webp";
import HollywoodIconDramaBack from "../assets/products/eye-06-back.webp";
import HollywoodIconDramaFront from "../assets/products/eye-06-front.webp";
import HollywoodIconBHNudeBack from "../assets/products/eye-07-back.webp";
import HollywoodIconBHNudeFront from "../assets/products/eye-07-front.webp";
import HollywoodIconBerryBack from "../assets/products/eye-08-back.webp";
import HollywoodIconBerryFront from "../assets/products/eye-08-front.webp";

const shopEye = [
  {
    id: 1,
    productBackImg: SitaKajalBack,
    productFrontImg: SitaKajalFront,
    isOutOfStock: false,
    productName: "Sita Kajal Intense Eyeliner",
    productPrice: "$16.00",
  },
  {
    id: 2,
    productBackImg: BombshellBrowBack,
    productFrontImg: BombshellBrowFront,
    isOutOfStock: false,
    productName: "Bombshell Brow & Lash Serum",
    productPrice: "$25.00",
  },
  {
    id: 3,
    productBackImg: HollywoodIconBack,
    productFrontImg: HollywoodIconFront,
    isOutOfStock: false,
    productName: "Hollywood Icon Face Kit - Sugar Daddy",
    productPrice: "$40.00",
  },
  {
    id: 4,
    productBackImg: HollywoodIconSapphireBack,
    productFrontImg: HollywoodIconSapphireFront,
    isOutOfStock: false,
    productName: "Hollywood Icon Face Kit - Sapphire Siren",
    productPrice: "$40.00",
  },
  {
    id: 5,
    productBackImg: HollywoodIconRodeoBack,
    productFrontImg: HollywoodIconRodeoFront,
    isOutOfStock: false,
    productName: "Hollywood Icon Face Kit - Rodeo Vamp",
    productPrice: "$40.00",
  },
  {
    id: 6,
    productBackImg: HollywoodIconDramaBack,
    productFrontImg: HollywoodIconDramaFront,
    isOutOfStock: false,
    productName: "Hollywood Icon Face Kit - Drama Queen",
    productPrice: "$40.00",
  },
  {
    id: 7,
    productBackImg: HollywoodIconBHNudeBack,
    productFrontImg: HollywoodIconBHNudeFront,
    isOutOfStock: false,
    productName: "Hollywood Icon Face Kit - BH Nude",
    productPrice: "$40.00",
  },
  {
    id: 8,
    productBackImg: HollywoodIconBerryBack,
    productFrontImg: HollywoodIconBerryFront,
    isOutOfStock: false,
    productName: "Hollywood Icon Face Kit - Berry DIva",
    productPrice: "$50.00",
  },
];

export default shopEye;
